import { authFetch } from './authFetch';

export interface PublishMovieResponse {
  publicationId: string;
  movieId: number;
  bundleUrl: string;
  version: number;
  schemaVersion: number;
  playerPath: string;
  playerUrl: string;
  publishedAt: string;
}

export async function publishMovie(movieId: number): Promise<PublishMovieResponse> {
  const response = await authFetch(`/api/movies/${movieId}/publish`, {
    method: 'POST',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    let message = `Publish failed (${response.status})`;
    try {
      const body = (await response.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      // ignore
    }
    throw new Error(message);
  }

  return (await response.json()) as PublishMovieResponse;
}

export function resolvePlayerUrl(result: PublishMovieResponse): string {
  if (result.playerUrl) return result.playerUrl;
  const origin = (import.meta.env.VITE_PLAYER_PUBLIC_ORIGIN as string | undefined)?.replace(/\/$/, '')
    ?? 'http://localhost:4100';
  return `${origin}${result.playerPath}`;
}
